import { PermissionMapping } from '@@/lib/permissions';

export type NotificationsPermission = 'admin';

export const notificationsPermissionMapping: PermissionMapping<NotificationsPermission>[] = [
  {
    permissionSetMapping: {
      admin: ['pronetx-management-admin']
    },
    urlSignature: '/admin/notifications',
    showInNavbar: false,
    label: 'Notifications'
  }
];

export default notificationsPermissionMapping;
